<template>

    <section class="checkout-section use-stretchcoins">
        <h1><span>3.</span>Use your stretchcoins!</h1>
        <div>
            <span>Click to subtract coins</span><span>Click to add coins</span>
        </div>
        <div>
            <div>
                <span :class="{disabled: (assigned_coins === 0)}" @click="doCoinAssignment('clear')"></span>
                <span :class="{disabled: (assigned_coins < 10)}" @click="doCoinAssignment(-10)"></span>
                <span :class="{disabled: (assigned_coins === 0)}" @click="doCoinAssignment(-1)"></span>
            </div>
            <div>
                <span :class="{disabled: ((coin_total - assigned_coins) < 1) || !local_wallet}" @click="doCoinAssignment(1)"></span>
                <span :class="{disabled: ((coin_total - assigned_coins) < 10) || local_wallet < 10}" @click="doCoinAssignment(10)"></span>
                <span :class="{disabled: (assigned_coins >= coin_total) || !local_wallet}" @click="doCoinAssignment('all')"></span>
            </div>
        </div>
        <div>
            <div>
                <h6>Your wallet</h6>
                <span class="coin-amount" :class="{ strike: assigned_coins }">{{ wallet }}</span>
                <span v-if="assigned_coins" class="coin-amount">{{ wallet - assigned_coins }}</span>
            </div>
            <div></div>
            <div>
                <h6 class="">You'll pay</h6>
                <div v-if="assigned_coins" class="final-price"
                     :class="{
                        enlarge: !payment_total,
                        finalized: !payment_total && !recalculating
                }">
                    <span class="coin-amount">{{ assigned_coins }}</span>
                </div>
                <div v-if="payment_total && !recalculating" class="final-price"
                     :class="{
                        enlarge: !assigned_coins,
                        plus: assigned_coins,
                        finalized: !recalculating,
                        invalid: invalid_payment_total
                }">
                    {{ $filters.getCurrencyValue(payment_total) }}
                    <span class="invalid-total">minimum charge: &pound;1</span>
                </div>
                <div v-if="recalculating" class=" recalculation-spinner"></div>
            </div>
        </div>
    </section>

</template>

<script>

export default {

	data(){
		return {
            assigned_coins: 0,
            invalid_payment_total: false
        }
    },
    props: {
	    payment_total: Number,
	    wallet: Number,
	    coins_used: Number,
	    coin_total: Number,
	    recalculating: Boolean
    },
    mounted()
    {
        this.assigned_coins = this.coins_used;
    },
    methods: {
		doCoinAssignment(amount)
        {
            switch(amount)
            {
                case 'all':
                	this.assigned_coins = this.coin_total > this.wallet ? this.wallet : this.coin_total;
                	break;
                case 'clear':
                	this.assigned_coins = 0;
                	break;
                default:
                	this.assigned_coins += amount;
                	break;
            }
            this.$emit('updated', this.assigned_coins);
        }
    },
    computed: {
		local_wallet(){
			return this.wallet - this.assigned_coins;
        }
    },
    watch: {
        coins_used()
        {
			this.assigned_coins = this.coins_used;
        },
        payment_total: {
        	immediate: true,
            handler(new_val){

        		const nextbtn = $('.checkout-navigation button');

                switch(true){
                    case new_val >= 1:
                    case new_val === 0:
                    	this.invalid_payment_total = false;
                    	nextbtn.attr('disabled', false);
                    	break;
                    case new_val < 1:
                    	this.invalid_payment_total = true;
                    	nextbtn.attr('disabled', true);
                    	break;
                }
            }
        }
    }

}

</script>























